var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgAlertLine = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7216 2.50006L18.6602 16.2501C18.8903 16.6487 18.7538 17.1583 18.3552 17.3884C18.2285 17.4616 18.0848 17.5001 17.9385 17.5001H2.06136C1.60113 17.5001 1.22803 17.127 1.22803 16.6668C1.22803 16.5204 1.26654 16.3768 1.33968 16.2501L9.27825 2.50006C9.50834 2.10148 10.018 1.96492 10.4166 2.19504C10.5433 2.26818 10.6485 2.37338 10.7216 2.50006ZM3.50474 15.8334H16.4951L9.99992 4.58339L3.50474 15.8334ZM9.16659 13.3334H10.8333V15.0001H9.16659V13.3334ZM9.16659 7.50006H10.8333V11.6668H9.16659V7.50006Z",
    fill: "#B54B07"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAlertLine, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/alert-line.3f40b6c6.svg";
export { ForwardRef as ReactComponent };